var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircumstances(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-1e9e2aaa": "",
    "data-v-304a6410": "",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon medium",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.464 11.9998H10V8.99976C10 8.60776 9.77 8.25176 9.414 8.08976C9.056 7.92576 8.636 7.98976 8.342 8.24776L0.342 15.2478C0.124 15.4378 0 15.7118 0 15.9998C0 16.2878 0.124 16.5618 0.342 16.7518L8.342 23.7518C8.636 24.0118 9.058 24.0738 9.414 23.9098C9.77 23.7478 10 23.3918 10 22.9998V19.9998H12.132L17.464 11.9998Z",
    fill: "#429E71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.658 15.2478L23.658 8.2478C23.364 7.9918 22.946 7.9298 22.586 8.0898C22.228 8.2518 22 8.6078 22 8.9998V11.9998H19.868L14.534 19.9998H22V22.9998C22 23.3918 22.228 23.7478 22.586 23.9098C22.718 23.9698 22.86 23.9998 23 23.9998C23.238 23.9998 23.472 23.9158 23.658 23.7518L31.658 16.7518C31.876 16.5618 32 16.2878 32 15.9998C32 15.7118 31.876 15.4378 31.658 15.2478Z",
    fill: "#429E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircumstances);
export default __webpack_public_path__ + "static/media/circumstances.7dcadd3256ea9c092b413d7da8989f09.svg";
export { ForwardRef as ReactComponent };